import angular from 'angular';
import MessagesListComponent from './messages-list-component';

export default angular.module('messages-list', []).component('messagesList', new MessagesListComponent());



// WEBPACK FOOTER //
// ./src/modules/message/components/messages-list/messages-list-module.js